import { render, staticRenderFns } from "./festivalDecorate.vue?vue&type=template&id=ced90ffe"
import script from "./festivalDecorate.vue?vue&type=script&lang=js"
export * from "./festivalDecorate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports